import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import BrandShape from '../../ui/icons/brand-shape';
import BPImage from '../../ui/v2/image';

import classes from './journey.module.css';

export type TJourney = {
  year: string;
  imgs: [
    {
      isflag?: boolean;
      src: string;
      alt: string;
      width: number;
      height: number;
    }
  ];
  description: string;
};

const Journey: FunctionComponent = () => {
  const { t } = useTranslation();
  const journey = t('about:journey.content', undefined, {
    returnObjects: true,
  }) as Array<TJourney>;
  return (
    <section>
      <div className="container m-auto py-6 lg:py-20 px-4">
        <ol className={cx(classes.timeline, 'flex', 'flex-col', 'lg:flex-row')}>
          {journey.map((item, index) => (
            <li
              key={item.year}
              className={cx(
                classes.item,
                'flex',
                'lg:flex-col',
                'items-center',
                'flex-1',
                'lg:py-0',
                'justify-items-center'
              )}
            >
              <div
                className={cx(
                  { [classes.centerFlag]: item.imgs[0].isflag },
                  classes.imagesWrapper,
                  'flex',
                  'lg:h-24',
                  'w-1/2',
                  'lg:w-auto',
                  'p-4'
                )}
              >
                {item.imgs.map((img) => (
                  <span
                    key={img.alt}
                    className={cx('px-1 h-10 flex items-center')}
                  >
                    <div
                      className={cx({
                        'rounded-xl shadow-md h-6 inline-block': img.isflag,
                      })}
                    >
                      {
                        <BPImage
                          src={img.src}
                          alt={img.alt}
                          width={img.width}
                          height={img.height}
                        />
                      }
                    </div>
                  </span>
                ))}
              </div>
              <h3
                title={item.year}
                className={cx(
                  'relative',
                  'block',
                  'text-neutral-30',
                  'h-6',
                  'w-6',
                  'order-2'
                )}
              >
                <span
                  className={cx(
                    classes.itemTitle,
                    'absolute block text-neutral-80 font-bold'
                  )}
                >
                  {item.year}
                </span>
                <BrandShape />
              </h3>
              <div
                className={cx(
                  classes.text,
                  'lg:h-24',
                  'flex',
                  'w-1/2',
                  'lg:w-auto',
                  'p-4'
                )}
              >
                <p className="lg:text-center">
                  <Trans
                    i18nKey={item.description}
                    components={{ break: <br /> }}
                  />
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Journey;
